module.exports = __webpack_public_path__ + "img/ch-3.f3e74bd9.jpeg";